module.exports = __webpack_public_path__ + "img/weibo.964f6506.png";